import {useQuery} from '@apollo/client';
import {renderCurrencyList} from './FinancialCards';
import {GET_WALLET_METRICS} from 'graphql/queries/financial';
import {useState} from 'react';
import styles from './financial.module.scss';
import {MetricsFilterBar} from './MetricsFilterBar';
import moment from 'moment';
import {Form} from 'antd';
import {ExportFinancialButton} from './ExportFinancialButton';
import {NavTabsEnum} from 'utils/constants';
import {useSelector} from 'react-redux';
import {makeSelectTabOperations} from 'redux/store/auth';

export const firstDayOfMonth = moment().startOf('month');
export const currentDayOfMonth = moment();

export const WalletMetrics = () => {
  const [data, setData] = useState([]);
  const [form] = Form.useForm();
  const startDate = Form.useWatch('startDate', form);
  const endDate = Form.useWatch('endDate', form);
  const allTime = Form.useWatch('allTime', form);
  const status = Form.useWatch('status', form);

  const tabOperations = useSelector(state =>
    makeSelectTabOperations(state, NavTabsEnum.Financials),
  );

  const {loading, refetch} = useQuery(GET_WALLET_METRICS, {
    variables: {
      filters: {
        date: {
          range: 'MONTHLY',
        },
      },
    },
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    onCompleted: data => setData(data?.getWalletMetrics?.data),
  });

  return (
    <>
      <MetricsFilterBar
        form={form}
        loading={loading}
        initialValues={{
          startDate: firstDayOfMonth,
          endDate: currentDayOfMonth,
        }}
        actions={
          tabOperations?.export ? (
            <ExportFinancialButton
              startDate={startDate}
              endDate={endDate}
              allTime={allTime}
              status={status}
              query={GET_WALLET_METRICS}
              type="Wallet"
            />
          ) : null
        }
        onFinish={values => {
          if (values?.allTime) {
            return refetch({
              'filters': {
                ...(values?.status && {status: values?.status}),
                'date': {
                  'range': 'MONTHLY',
                },
                'allTime': true,
              },
            });
          }
          if (!values?.startDate && !values?.endDate) {
            return refetch({
              filters: {
                ...(values?.status && {status: values?.status}),
                date: {
                  range: 'MONTHLY',
                },
              },
            });
          }
          refetch({
            filters: {
              ...(values?.status && {status: values?.status}),
              date: {
                ...(values?.startDate && {
                  startDate: moment(values?.startDate).format(),
                }),
                ...(values?.endDate && {
                  endDate: moment(values?.endDate).format(),
                }),
              },
            },
          });
        }}
      />
      <div className={styles.metricCardsRow}>
        <div className={styles.metricCardBox}>
          <div className={styles.sectionHead}>
            <h2 className={styles.sectionTitle}>Total wallet revenue</h2>
            <p className={styles.sectionNote}>
              Deposits, withdrawals and swaps combined.
            </p>
          </div>
          <div className={styles.metricCardList}>
            {renderCurrencyList(data?.totalRevenue, loading)}
          </div>
        </div>
        <div className={styles.metricCardBox}>
          <div className={styles.sectionHead}>
            <h2 className={styles.sectionTitle}>Gross deposit fees</h2>
            <p className={styles.sectionNote}>Fees generated from deposits.</p>
          </div>
          <div className={styles.metricCardList}>
            {renderCurrencyList(data?.grossDepositFees, loading)}
          </div>
        </div>
        <div className={styles.metricCardBox}>
          <div className={styles.sectionHead}>
            <h2 className={styles.sectionTitle}>Gross withdrawal fees</h2>
            <p className={styles.sectionNote}>
              Fees generated from withdrawals.
            </p>
          </div>
          <div className={styles.metricCardList}>
            {renderCurrencyList(data?.grossWithdrawalFees, loading)}
          </div>
        </div>
        <div className={styles.metricCardBox}>
          <div className={styles.sectionHead}>
            <h2 className={styles.sectionTitle}>Gross swap fees</h2>
            <p className={styles.sectionNote}>
              Fees generated from currency swaps.
            </p>
          </div>
          <div className={styles.metricCardList}>
            {renderCurrencyList(data?.grossSwapFees, loading)}
          </div>
        </div>
      </div>
    </>
  );
};
